module.exports = __webpack_public_path__ + "media/bootstrap-icons/droplet-fill-797ed189.svg";